import { render } from "./UnorganizedMod.vue?vue&type=template&id=66943588&scoped=true"
import script from "./UnorganizedMod.vue?vue&type=script&lang=js"
export * from "./UnorganizedMod.vue?vue&type=script&lang=js"

import "./UnorganizedMod.vue?vue&type=style&index=0&id=66943588&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66943588"]])

export default __exports__